import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import PaymentsIcon from '@mui/icons-material/Payments';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import BusinessIcon from '@mui/icons-material/Business';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import ApartmentIcon from '@mui/icons-material/Apartment';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TuneIcon from '@mui/icons-material/Tune';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import BarChartIcon from '@mui/icons-material/BarChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import MapIcon from '@mui/icons-material/Map';
import SchoolIcon from '@mui/icons-material/School';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Collapse from '@mui/material/Collapse';
import MenuJson from 'Components/MenuConfig';
import { Actions, screenTypes } from 'Constants/permissions';
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from '@mui/icons-material/Search';
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Avatar from '@mui/material/Avatar';
import { Popper, Grow, Paper, MenuItem, MenuList, Tooltip, Popover } from "@mui/material/";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Swal from 'sweetalert2';
import { postRequest } from 'Includes/api/apicall';
import { POST_URL } from 'Includes/urls';
import './DrawerNew.scss'
import {logout} from 'Includes/functions';
import logoImage from 'images/edubricz.jpeg';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRequest } from 'Includes/api/apicall';
import { GET_URL } from 'Includes/urls';

const drawerWidth = 260;
const TOPBAR_TITLE = 'Edubricz Signup';
const BRAND_PRIMARY = '#4680FF';
const BRAND_DEEP = '#1665D8';

const MENU_ICON_COLORS = {
  dashboard: '#4680FF',
  finance: '#7C3AED',
  company: '#0EA5E9',
  users: '#EC4899',
  tickets: '#F59E0B',
  basic: '#64748B',
  billing: '#10B981',
  orders: '#8B5CF6',
  reports: '#EF4444',
  payments: '#14B8A6',
  expenses: '#F97316',
  tasks: '#6366F1',
  permissions: '#A855F7',
  notifications: '#EAB308',
  documents: '#3B82F6',
  help: '#22C55E',
  default: '#4680FF',
  areasearch: '#06B6D4',
  sales: '#F97316',
};

const coloredIcon = (Icon, color) => (
  <Icon sx={{ color, fontSize: 22 }} />
);

const getMenuIcon = (menuKey) => {
  const key = (menuKey || '').toLowerCase();
  const directIconMap = {
    dashboard: <SpaceDashboardIcon />,
    'finance dashboard': <AssessmentIcon />,
    'company list': <ApartmentIcon />,
    'users list': <PeopleIcon />,
    'ticket list': <SupportAgentIcon />,
    'basic details': <TuneIcon />,
    'billing setup': <CurrencyRupeeIcon />,
    'orders and invoices': <ReceiptLongIcon />,
    reports: <BarChartIcon />,
    'client report': <AssessmentIcon />,
    'payment gateway': <PaymentsIcon />,
    expenses: <AccountBalanceWalletIcon />,
    'task management': <TaskAltIcon />,
    permissions: <AdminPanelSettingsIcon />,
    'visits map': <MapIcon />,
    dashboard: coloredIcon(SpaceDashboardIcon, MENU_ICON_COLORS.dashboard),
    'finance dashboard': coloredIcon(AssessmentIcon, MENU_ICON_COLORS.finance),
    'company list': coloredIcon(ApartmentIcon, MENU_ICON_COLORS.company),
    'users list': coloredIcon(PeopleIcon, MENU_ICON_COLORS.users),
    'ticket list': coloredIcon(SupportAgentIcon, MENU_ICON_COLORS.tickets),
    'basic details': coloredIcon(TuneIcon, MENU_ICON_COLORS.basic),
    'billing setup': coloredIcon(CurrencyRupeeIcon, MENU_ICON_COLORS.billing),
    'orders and invoices': coloredIcon(ReceiptLongIcon, MENU_ICON_COLORS.orders),
    reports: coloredIcon(BarChartIcon, MENU_ICON_COLORS.reports),
    'client report': coloredIcon(AssessmentIcon, MENU_ICON_COLORS.reports),
    'payment gateway': coloredIcon(PaymentsIcon, MENU_ICON_COLORS.payments),
    expenses: coloredIcon(AccountBalanceWalletIcon, MENU_ICON_COLORS.expenses),
    'task management': coloredIcon(TaskAltIcon, MENU_ICON_COLORS.tasks),
    permissions: coloredIcon(AdminPanelSettingsIcon, MENU_ICON_COLORS.permissions),
    'area search': coloredIcon(SchoolIcon, MENU_ICON_COLORS.areasearch),
    'sales visit': coloredIcon(DirectionsWalkIcon, MENU_ICON_COLORS.sales),
    'sales tracking': coloredIcon(DirectionsWalkIcon, MENU_ICON_COLORS.sales),
    'sales & support': coloredIcon(DirectionsWalkIcon, MENU_ICON_COLORS.sales),
  };

  if (directIconMap[key]) {
    return directIconMap[key];
  }

  if (key.includes('basic') || key.includes('setting')) {
    return coloredIcon(SettingsIcon, MENU_ICON_COLORS.basic);
  }
  if (key.includes('company')) {
    return coloredIcon(BusinessIcon, MENU_ICON_COLORS.company);
  }
  if (key.includes('user') || key.includes('staff') || key.includes('student')) {
    return coloredIcon(PeopleIcon, MENU_ICON_COLORS.users);
  }
  if (key.includes('billing') || key.includes('wallet') || key.includes('subscription') || key.includes('payment') || key.includes('expense') || key.includes('order') || key.includes('invoice')) {
    return coloredIcon(PaymentsIcon, MENU_ICON_COLORS.billing);
  }
  if (key.includes('notice') || key.includes('reminder') || key.includes('notification')) {
    return coloredIcon(NotificationsIcon, MENU_ICON_COLORS.notifications);
  }
  if (key.includes('report')) {
    return coloredIcon(AssessmentIcon, MENU_ICON_COLORS.reports);
  }
  if (key.includes('agreement') || key.includes('document')) {
    return coloredIcon(DescriptionIcon, MENU_ICON_COLORS.documents);
  }
  if (key.includes('help') || key.includes('support') || key.includes('ticket')) {
    return coloredIcon(HelpCenterIcon, MENU_ICON_COLORS.help);
  }

  return coloredIcon(DashboardIcon, MENU_ICON_COLORS.default);
};

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: `linear-gradient(90deg, ${BRAND_DEEP} 0%, ${BRAND_PRIMARY} 100%)`,
  boxShadow: '0 1px 0 rgba(0,0,0,0.06)',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  }),
}));

const Drawer = styled(MuiDrawer, {
  // Keep `open` on MuiDrawer. Temporary (mobile) drawers stay closed if it is stripped.
  shouldForwardProp: (prop) => prop !== 'ismobile',
})(({ theme, open, ismobile }) => ({
  ...(ismobile
    ? {
        width: 0,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }
    : {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        }),
      }),
}));

function MiniDrawer(props) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const [open, setOpen] = React.useState(!isMobile);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [userInfo, setUserInfo] = React.useState({});
  const [companySearchLoading, setCompanySearchLoading] = React.useState(false);
  const [companySearchOptions, setCompanySearchOptions] = React.useState([]);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  const [companySearchText, setCompanySearchText] = React.useState('');
  const [companySearchPageNo, setCompanySearchPageNo] = React.useState(1);
  const [companySearchHasMore, setCompanySearchHasMore] = React.useState(true);
  const [companySearchTotalCount, setCompanySearchTotalCount] = React.useState(0);
  const [menuSearchText, setMenuSearchText] = React.useState('');
  const [selectedMenuOption, setSelectedMenuOption] = React.useState(null);
  const [menuSearchAnchorEl, setMenuSearchAnchorEl] = React.useState(null);
  const [menuConfig, setMenuConfig] = React.useState(MenuJson);
  const [isServerMenu, setIsServerMenu] = React.useState(false);
  const anchorRef = React.useRef(null);
  const menuSearchButtonRef = React.useRef(null);
  const menuSearchInputRef = React.useRef(null);
  const menuSearchOpen = Boolean(menuSearchAnchorEl);
  const [openSubMenus, setOpenSubMenus] = React.useState({});
  const [passwordDialogOpen, setPasswordDialogOpen] = React.useState(false);
  const [newPassword, setNewPassword] = React.useState('');
  const [savingPassword, setSavingPassword] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const currentPath = useLocation().pathname || '';
  const navigate = useNavigate();
  const displayName = userInfo?.username || '';
  const userInitial = displayName ? displayName.charAt(0).toUpperCase() : '';

  React.useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const normalizePath = React.useCallback((path) => {
    if (!path) return '';
    return path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
  }, []);

  const isPathActive = React.useCallback((targetPath) => {
    const normalizedCurrentPath = normalizePath(currentPath);
    const normalizedTargetPath = normalizePath(targetPath);
    if (!normalizedTargetPath) return false;
    return (
      normalizedCurrentPath === normalizedTargetPath ||
      normalizedCurrentPath.startsWith(`${normalizedTargetPath}/`)
    );
  }, [currentPath, normalizePath]);

  // Load user + menu from localStorage after login.
  React.useEffect(() => {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    const storedMenu = localStorage.getItem('menu');
    try {
      const rawPerms = localStorage.getItem('permissions');
      if (rawPerms) {
        const parsed = JSON.parse(rawPerms);
        if (Array.isArray(parsed) && parsed.length && !Array.isArray(u.permission_codenames)) {
          u.permission_codenames = parsed;
        }
      }
    } catch (e) {
      /* ignore */
    }
    try {
      if (storedMenu) {
        const parsedMenu = JSON.parse(storedMenu);
        if (parsedMenu && typeof parsedMenu === 'object' && !Array.isArray(parsedMenu)) {
          if (parsedMenu["Sales Tracking"]) {
            parsedMenu["Sales Visit"] = parsedMenu["Sales Tracking"];
            delete parsedMenu["Sales Tracking"];
          }
          delete parsedMenu["Support Visits"];
          const supportVisitUrls = new Set(["/visits/list", "/visits/my", "/visits/company-overall"]);
          Object.keys(parsedMenu).forEach((menuKey) => {
            const subMenu = parsedMenu[menuKey]?.subMenu;
            if (!subMenu) return;
            Object.keys(subMenu).forEach((subKey) => {
              if (supportVisitUrls.has(subMenu[subKey]?.url)) delete subMenu[subKey];
            });
            if (Object.keys(subMenu).length === 0) delete parsedMenu[menuKey];
          });
          const salesKey = parsedMenu["Sales & Support"]
            ? "Sales & Support"
            : (parsedMenu["Sales Visit"] ? "Sales Visit" : null);
          const salesVisit = salesKey ? parsedMenu[salesKey] : null;
          if (salesVisit) {
            const existing = salesVisit.subMenu || {};
            const byUrl = {};
            Object.keys(existing).forEach((key) => {
              const item = existing[key];
              if (item?.url) byUrl[item.url] = item;
            });
            const ordered = [
              ["Dashboard", "/sales-dashboard"],
              ["Visit Planner", "/sales/visit-planner"],
              ["Unplanned", "/sales/unplanned"],
              ["My Visits", "/sales/my-visits"],
              ["All Schools", "/area-search"],
              ["Visits", "/sales/visits"],
              ["Sales Track", "/sales/track"],
              ["My Sales Track", "/sales/my-track"],
              ["Sales Persons Expenses", "/sales/persons"],
            ];
            const nextSub = {};
            ordered.forEach(([label, url]) => {
              nextSub[label] = byUrl[url] ? { ...byUrl[url], url } : { url };
            });
            salesVisit.subMenu = nextSub;
            if (salesKey !== "Sales & Support") {
              const renamed = {};
              Object.keys(parsedMenu).forEach((key) => {
                renamed[key === salesKey ? "Sales & Support" : key] = parsedMenu[key];
              });
              Object.keys(parsedMenu).forEach((key) => { delete parsedMenu[key]; });
              Object.assign(parsedMenu, renamed);
            }
          }
          const basicDetails = parsedMenu["Basic Details"];
          if (basicDetails?.subMenu && !basicDetails.subMenu["Edubricz ads"]) {
            basicDetails.subMenu = {
              ...basicDetails.subMenu,
              "Edubricz ads": { url: "/basicdetails/edubricz-ads" },
            };
          }
          if (basicDetails?.subMenu && !basicDetails.subMenu["Feature Adds"]) {
            basicDetails.subMenu = {
              ...basicDetails.subMenu,
              "Feature Adds": { url: "/basicdetails/feature-adds" },
            };
          }
          if (basicDetails?.subMenu && !basicDetails.subMenu["Edubricz Permission"]) {
            basicDetails.subMenu = {
              ...basicDetails.subMenu,
              "Edubricz Permission": { url: "/basicdetails/edubricz-permission" },
            };
          }
          const ordersMenu = parsedMenu["Orders and Invoices"];
          if (ordersMenu?.subMenu && !ordersMenu.subMenu["ID Card Orders"]) {
            const nextSub = {};
            Object.keys(ordersMenu.subMenu).forEach((label) => {
              nextSub[label] = ordersMenu.subMenu[label];
              if (label === "Orders V2") {
                nextSub["ID Card Orders"] = { url: "/billing/orders-v2/id-cards" };
              }
            });
            if (!nextSub["ID Card Orders"]) {
              nextSub["ID Card Orders"] = { url: "/billing/orders-v2/id-cards" };
            }
            ordersMenu.subMenu = nextSub;
          }
          const taskManagement = parsedMenu["Task Management"];
          if (taskManagement?.subMenu) {
            taskManagement.subMenu = {
              ...taskManagement.subMenu,
              "My Leaves": taskManagement.subMenu["My Leaves"] || { url: "/task/my-leaves" },
              "Leave Management": taskManagement.subMenu["Leave Management"] || { url: "/task/leave-management" },
            };
          }
          setMenuConfig(parsedMenu);
          setIsServerMenu(true);
        }
      }
    } catch (e) {
      setMenuConfig(MenuJson);
      setIsServerMenu(false);
    }
    setUserInfo(u);
  }, []);

  const searchReqIdRef = React.useRef(0);

  const fetchCompaniesPage = React.useCallback(async ({ pageNo, searchText, mode }) => {
    const limit = 15;
    const params = { limit, pageno: pageNo };
    const q = String(searchText || '').trim();
    if (q) params.search = q;

    const reqId = ++searchReqIdRef.current;
    setCompanySearchLoading(true);
    try {
      const response = await getRequest(`${GET_URL.company.api}search/`, params, props);
      if (reqId !== searchReqIdRef.current) return;
      if (response && response.status === 200) {
        const list = response?.data?.data || [];
        const totalCount = Number(response?.data?.count ?? 0);
        const incoming = Array.isArray(list) ? list : [];
        const hasMoreFlag = Boolean(response?.data?.has_more);

        setCompanySearchTotalCount(Number.isFinite(totalCount) ? totalCount : 0);

        setCompanySearchOptions((prev) => {
          const next =
            mode === 'replace'
              ? incoming
              : (() => {
                  const seen = new Set((prev || []).map((c) => c?.id));
                  const merged = [...(prev || [])];
                  incoming.forEach((c) => {
                    if (!seen.has(c?.id)) {
                      merged.push(c);
                      seen.add(c?.id);
                    }
                  });
                  return merged;
                })();

          setCompanySearchHasMore(hasMoreFlag);
          return next;
        });
      }
    } catch (_e) {
      if (reqId === searchReqIdRef.current) {
        setCompanySearchHasMore(false);
        if (mode === 'replace') setCompanySearchOptions([]);
      }
    } finally {
      if (reqId === searchReqIdRef.current) {
        setCompanySearchLoading(false);
      }
    }
  }, [props]);

  React.useEffect(() => {
    // initial load (page 1)
    fetchCompaniesPage({ pageNo: 1, searchText: '', mode: 'replace' });
  }, [fetchCompaniesPage]);

  React.useEffect(() => {
    // when search text changes, restart pagination at page 1
    const handle = window.setTimeout(() => {
      setCompanySearchPageNo(1);
      setCompanySearchHasMore(true);
      setCompanySearchTotalCount(0);
      fetchCompaniesPage({ pageNo: 1, searchText: companySearchText, mode: 'replace' });
    }, 300);
    return () => window.clearTimeout(handle);
  }, [companySearchText, fetchCompaniesPage]);

  const maybeLoadNextCompanyPage = React.useCallback((scrollNode) => {
    if (!scrollNode) return;
    const thresholdPx = 56;
    const isNearBottom =
      scrollNode.scrollTop + scrollNode.clientHeight >= scrollNode.scrollHeight - thresholdPx;
    if (!isNearBottom) return;
    if (companySearchLoading) return;
    if (!companySearchHasMore) return;

    const nextPage = companySearchPageNo + 1;
    setCompanySearchPageNo(nextPage);
    fetchCompaniesPage({ pageNo: nextPage, searchText: companySearchText, mode: 'append' });
  }, [
    companySearchHasMore,
    companySearchLoading,
    companySearchPageNo,
    companySearchText,
    fetchCompaniesPage,
  ]);

  // Treat both Django superuser and superadmin role/group as full-access users.
  const isSuperuser = React.useMemo(() => {
    if (userInfo?.is_superuser) return true;
    const roleName = (userInfo?.role || userInfo?.user_type || '').toString().toLowerCase();
    if (roleName === 'superadmin' || roleName === 'super_admin') return true;
    const groupNames = (userInfo?.groups || [])
      .map((groupItem) =>
        (typeof groupItem === 'string' ? groupItem : groupItem?.name || '')
          .toString()
          .toLowerCase()
      )
      .filter(Boolean);
    return groupNames.includes('superadmin') || groupNames.includes('super_admin');
  }, [userInfo]);

  /** Codenames the user has: login sends permission_codenames; legacy shapes still supported. */
  const userPermissionCodes = React.useMemo(() => {
    const normalizeCode = (p) => {
      if (!p) return null;
      if (typeof p === 'string') return p;
      if (typeof p === 'object') {
        return p.codename || p.action_code || p.code || p.name || null;
      }
      return null;
    };

    if (Array.isArray(userInfo?.permission_codenames) && userInfo.permission_codenames.length) {
      const codes = userInfo.permission_codenames.map(normalizeCode).filter(Boolean);
      return new Set(codes);
    }
    const own = (userInfo?.user_permissions || userInfo?.permissions || []).map((p) =>
      normalizeCode(p)
    );
    const fromGroups = (userInfo?.groups || [])
      .flatMap((g) => g?.permissions || [])
      .map((p) => normalizeCode(p));
    return new Set([...own, ...fromGroups].filter(Boolean));
  }, [userInfo]);

  /** Map menu route -> required action_code (prefer view) for permission_needed entries. */
  const urlToRequiredCodename = React.useMemo(() => {
    const map = {};
    const norm = (p) => {
      if (!p) return '';
      return p.endsWith('/') && p !== '/' ? p.slice(0, -1) : p;
    };
    Object.keys(Actions).forEach((actionKey) => {
      const action = Actions[actionKey];
      screenTypes.forEach((st) => {
        const sa = action[st];
        if (!sa?.url || !sa?.permission_needed || !sa?.action_code) return;
        const path = norm(sa.url);
        if (!path) return;
        if (st === 'view' && !map[path]) {
          map[path] = sa.action_code;
        }
      });
    });
    Object.keys(Actions).forEach((actionKey) => {
      const action = Actions[actionKey];
      // Include bulk_create so menu items like Bulk Issue Invoice / Bulk Orders are gated
      ['create', 'update', 'delete', 'bulk_create'].forEach((st) => {
        const sa = action[st];
        if (!sa?.url || !sa?.permission_needed || !sa?.action_code) return;
        const path = norm(sa.url);
        if (!map[path]) map[path] = sa.action_code;
      });
    });
    return map;
  }, []);

  const userCanAccessMenuUrl = React.useCallback(
    (url) => {
      if (!url) return false;
      if (isSuperuser) return true;
      const path = normalizePath(url);
      if (path === '/billing/orders-v2/id-cards') {
        return userPermissionCodes.has('visible_orders_v2_view')
          || userPermissionCodes.has('visible_id_card_orders_view');
      }
      const required = urlToRequiredCodename[path];
      if (!required) return true;
      return userPermissionCodes.has(required);
    },
    [isSuperuser, normalizePath, urlToRequiredCodename, userPermissionCodes]
  );



  // Filter menu: superuser-only routes + permission codenames for each URL
  const filteredMenuJson = React.useMemo(() => {
    // If backend already provided a menu but we don't have permission codes available on the client,
    // trust the server menu instead of filtering everything out.
    if (!isSuperuser && isServerMenu && userPermissionCodes.size === 0) {
      return { ...menuConfig };
    }
    const menu = { ...menuConfig };
    const filtered = {};
    
    // Filter top-level menu items
    Object.keys(menu).forEach(menuKey => {
      const menuItem = menu[menuKey];
      
      // Check if menu item has a direct URL
      if (menuItem.url) {
        const permOk = userCanAccessMenuUrl(menuItem.url);
        if (permOk) {
          filtered[menuKey] = { ...menuItem };
        }
      }
      // Check if menu item has subMenu
      else if (menuItem.subMenu) {
        const filteredSubMenu = {};
        
        // Filter submenu items
        Object.keys(menuItem.subMenu).forEach(subMenuKey => {
          const subMenuItem = menuItem.subMenu[subMenuKey];
          if (subMenuItem.url) {
            const permOk = userCanAccessMenuUrl(subMenuItem.url);
            if (permOk) {
              filteredSubMenu[subMenuKey] = { ...subMenuItem };
            }
          } else {
            // If no URL, include it (shouldn't happen but just in case)
            filteredSubMenu[subMenuKey] = { ...subMenuItem };
          }
        });
        
        // Only include parent menu if it has at least one submenu item
        if (Object.keys(filteredSubMenu).length > 0) {
          filtered[menuKey] = {
            ...menuItem,
            subMenu: filteredSubMenu
          };
        }
      } else {
        // If no URL and no subMenu, include it (shouldn't happen but just in case)
        filtered[menuKey] = { ...menuItem };
      }
    });
    
    return filtered;
  }, [isSuperuser, userCanAccessMenuUrl, menuConfig, isServerMenu, userPermissionCodes]);

  // Flatten permission-filtered menus for the header menu search.
  const searchableMenuOptions = React.useMemo(() => {
    const items = [];
    Object.keys(filteredMenuJson || {}).forEach((menuKey) => {
      const menuItem = filteredMenuJson[menuKey];
      if (!menuItem) return;
      if (menuItem.url) {
        items.push({
          id: menuItem.url,
          label: menuKey,
          group: null,
          url: menuItem.url,
        });
        return;
      }
      if (menuItem.subMenu) {
        Object.keys(menuItem.subMenu).forEach((subKey) => {
          const subMenuItem = menuItem.subMenu[subKey];
          if (!subMenuItem?.url) return;
          items.push({
            id: `${menuKey}::${subKey}`,
            label: subKey,
            group: menuKey,
            url: subMenuItem.url,
          });
        });
      }
    });
    return items;
  }, [filteredMenuJson]);

  const openMenuSearch = React.useCallback((anchorEl) => {
    const el = anchorEl || menuSearchButtonRef.current;
    if (!el) return;
    setMenuSearchAnchorEl(el);
    setMenuSearchText('');
    setSelectedMenuOption(null);
  }, []);

  const closeMenuSearch = React.useCallback(() => {
    setMenuSearchAnchorEl(null);
    setMenuSearchText('');
    setSelectedMenuOption(null);
  }, []);

  React.useEffect(() => {
    const onKeyDown = (event) => {
      if (!(event.ctrlKey && event.shiftKey)) return;
      const key = String(event.key || '').toLowerCase();
      if (key !== 'f') return;
      event.preventDefault();
      openMenuSearch();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [openMenuSearch]);

  React.useEffect(() => {
    if (!menuSearchOpen) return undefined;
    const handle = window.setTimeout(() => {
      menuSearchInputRef.current?.focus();
    }, 50);
    return () => window.clearTimeout(handle);
  }, [menuSearchOpen]);

  const salesSubButtons = React.useMemo(() => {
    const salesKey = Object.keys(filteredMenuJson || {}).find((key) => key === 'Sales & Support' || key === 'Sales Visit' || key === 'Sales Tracking');
    const subMenu = salesKey ? filteredMenuJson[salesKey]?.subMenu : null;
    if (!subMenu) return [];
    const shortLabel = {
      'Visit Planner': 'Planner',
      'All Schools': 'Schools',
      'Sales Track': 'Track',
      'My Sales Track': 'My Track',
      'Sales Persons Expenses': 'Expenses',
      'Visits Map': 'Map',
    };
    return Object.keys(subMenu)
      .map((label) => ({ label: shortLabel[label] || label, url: subMenu[label]?.url }))
      .filter((item) => item.url);
  }, [filteredMenuJson]);

  const showSalesSubnav = isMobile && salesSubButtons.some((item) => isPathActive(item.url));

  const isMenuRowSelected = React.useCallback((text) => {
    const item = filteredMenuJson[text];
    if (!item) return false;
    if (item.subMenu) {
      return Object.keys(item.subMenu).some((sk) => isPathActive(item.subMenu[sk]?.url));
    }
    return Boolean(item.url && isPathActive(item.url));
  }, [filteredMenuJson, isPathActive]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleDrawerToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleMenu = (text) => {
    if (filteredMenuJson[text] && filteredMenuJson[text]['subMenu']) {
      if (!open) {
        setOpen(true);
        setOpenSubMenus((prev) => ({ ...prev, [text]: true }));
        return;
      }
      // Preserve other sections; only toggle this parent (was replacing entire state).
      setOpenSubMenus((prev) => ({
        ...prev,
        [text]: !prev[text],
      }));
    } else if (filteredMenuJson[text] && filteredMenuJson[text]['url']) {
      navigate(filteredMenuJson[text]['url']);
      if (isMobile) setOpen(false);
    }
  }

  const handleSubMenu = (parentText, subText) => {
    if (filteredMenuJson[parentText] && filteredMenuJson[parentText]['subMenu'] && filteredMenuJson[parentText]['subMenu'][subText]) {
      navigate(filteredMenuJson[parentText]['subMenu'][subText]['url']);
      if (isMobile) setOpen(false);
    }
  }

  const handleAccountMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleAccountMenuClose = () => {
    setIsMenuOpen(false);
  };

  const handlePasswordDialogOpen = () => {
    setNewPassword('');
    setShowPassword(false);
    setPasswordDialogOpen(true);
    handleAccountMenuClose();
  };

  const handlePasswordDialogClose = () => {
    setPasswordDialogOpen(false);
  };

  const handlePasswordSave = async () => {
    if (!newPassword || newPassword.length < 6) {
      Swal.fire({ icon: 'warning', title: 'Password must be at least 6 characters' });
      return;
    }
    setSavingPassword(true);
    try {
      const payload = {
        username: userInfo?.username,
        new_password: newPassword,
        company: null
      };
      const response = await postRequest(POST_URL.changepassword.api, payload, props);
      if (response && response.status === 200) {
        Swal.fire({ position: 'top-end', icon: 'success', title: 'Password changed successfully', showConfirmButton: false, timer: 1500 });
        handlePasswordDialogClose();
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: error?.response?.data?.Reason || 'Unable to change password' });
    } finally {
      setSavingPassword(false);
    }
  };

  const logoutFromScreen = () => {
    logout();
  };

  // Keep submenu expand state aligned with the current route: open parents that contain
  // the active URL, and close others so stale sections (e.g. Basic Details) do not stay
  // expanded on Ticket list and similar routes.
  React.useEffect(() => {
    setOpenSubMenus((prev) => {
      const next = { ...prev };
      Object.keys(filteredMenuJson).forEach((menuKey) => {
        const menuItem = filteredMenuJson[menuKey];
        if (!menuItem?.subMenu) return;
        const hasActiveSubMenu = Object.keys(menuItem.subMenu).some(
          (subKey) => isPathActive(menuItem.subMenu[subKey]?.url)
        );
        if (hasActiveSubMenu) {
          next[menuKey] = true;
        } else {
          delete next[menuKey];
        }
      });
      return next;
    });
  }, [filteredMenuJson, currentPath, isPathActive]);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={!isMobile && open} elevation={0}>
        <Toolbar
          className="globalTopbar"
          disableGutters
          sx={{
            px: { xs: 1.5, sm: 2.5 },
            gap: 1.75,
            minHeight: '66px !important',
          }}
        >
          <IconButton
            color="inherit"
            aria-label={open ? 'close drawer' : 'open drawer'}
            onClick={isMobile ? handleDrawerToggle : handleDrawerOpen}
            edge="start"
            sx={{
              mr: 1,
              ...(!isMobile && open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontWeight: 700,
                letterSpacing: 0.15,
                lineHeight: 1.1,
                fontSize: { xs: '1rem', sm: '1.1rem' },
              }}
            >
              {TOPBAR_TITLE}
            </Typography>
            <Typography
              variant="caption"
              noWrap
              sx={{
                display: 'block',
                opacity: 0.92,
                mt: 0.25,
                fontWeight: 500,
                fontSize: '0.74rem',
                letterSpacing: 0.12,
              }}
            >
              {displayName ? `Signed in as ${displayName}` : 'Signed in'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto', gap: 0.75 }}>
            <Tooltip title="Search menu (Ctrl+Shift+F)" disableHoverListener={menuSearchOpen}>
              <IconButton
                color="inherit"
                aria-label="search menu"
                aria-expanded={menuSearchOpen ? 'true' : undefined}
                onClick={(event) => {
                  if (menuSearchOpen) {
                    closeMenuSearch();
                  } else {
                    openMenuSearch(event.currentTarget);
                  }
                }}
                ref={menuSearchButtonRef}
                sx={{
                  border: '1px solid rgba(255,255,255,0.42)',
                  backgroundColor: menuSearchOpen ? 'rgba(255,255,255,0.28)' : 'rgba(255,255,255,0.12)',
                  width: 38,
                  height: 38,
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
                }}
              >
                <SearchIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Popover
              open={menuSearchOpen}
              anchorEl={menuSearchAnchorEl}
              onClose={closeMenuSearch}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              marginThreshold={8}
              PaperProps={{
                sx: {
                  mt: 1,
                  p: 1.5,
                  width: 320,
                  borderRadius: 1.5,
                  overflow: 'visible',
                },
              }}
              disableRestoreFocus
            >
              <Autocomplete
                openOnFocus
                autoHighlight
                disablePortal
                options={searchableMenuOptions}
                value={selectedMenuOption}
                inputValue={menuSearchText}
                onInputChange={(_event, nextValue) => {
                  setMenuSearchText(nextValue);
                }}
                onChange={(_event, nextValue) => {
                  setSelectedMenuOption(nextValue);
                  if (nextValue?.url) {
                    navigate(nextValue.url);
                    closeMenuSearch();
                  }
                }}
                getOptionLabel={(option) => {
                  if (!option) return '';
                  if (typeof option === 'string') return option;
                  return option?.label || '';
                }}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                filterOptions={(options, state) => {
                  const q = String(state.inputValue || '').trim().toLowerCase();
                  if (!q) return options;
                  return options.filter((option) => {
                    const label = String(option?.label || '').toLowerCase();
                    const group = String(option?.group || '').toLowerCase();
                    return label.includes(q) || group.includes(q);
                  });
                }}
                noOptionsText="No matching menus"
                renderOption={(optionProps, option) => (
                  <li {...optionProps} key={option?.id}>
                    {option?.label}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    autoFocus
                    label="Search Menus"
                    variant="outlined"
                    size="small"
                    inputRef={menuSearchInputRef}
                  />
                )}
                ListboxProps={{
                  style: { maxHeight: 280, overflow: 'auto' },
                }}
                sx={{ width: '100%' }}
              />
            </Popover>
            <Autocomplete
              size="small"
              value={selectedCompany}
              options={companySearchOptions}
              loading={companySearchLoading}
              inputValue={companySearchText}
              onInputChange={(_event, nextValue) => {
                setCompanySearchText(nextValue);
              }}
              onChange={(_event, nextValue) => {
                setSelectedCompany(nextValue);
                const id = nextValue?.id;
                if (id) {
                  navigate(`/company/details/${id}`);
                }
              }}
              getOptionLabel={(option) => {
                if (!option) return '';
                if (typeof option === 'string') return option;
                return option?.name || option?.company_name || '';
              }}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              renderOption={(optionProps, option) => {
                const name = option?.name || option?.company_name || '-';
                const isActive = Boolean(option?.is_active);
                return (
                  <Box
                    component="li"
                    {...optionProps}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 2,
                    }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {name}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 700,
                        px: 1,
                        py: 0.25,
                        borderRadius: 999,
                        color: isActive ? '#14532D' : '#7F1D1D',
                        bgcolor: isActive ? '#DCFCE7' : '#FEE2E2',
                        border: '1px solid',
                        borderColor: isActive ? '#86EFAC' : '#FCA5A5',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {isActive ? 'Active' : 'Disabled'}
                    </Typography>
                  </Box>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search company"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {companySearchLoading ? (
                          <CircularProgress color="inherit" size={16} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                    sx: {
                      bgcolor: 'rgba(255,255,255,0.12)',
                      borderRadius: 2,
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255,255,255,0.42)',
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255,255,255,0.65)',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255,255,255,0.85)',
                      },
                      '& input': { color: 'white', fontWeight: 600 },
                      '& input::placeholder': { color: 'rgba(255,255,255,0.75)', opacity: 1 },
                    },
                  }}
                />
              )}
              ListboxProps={{
                style: { maxHeight: 320, overflow: 'auto' },
                onScroll: (event) => maybeLoadNextCompanyPage(event.currentTarget),
              }}
              componentsProps={{
                paper: {
                  onScroll: (event) => maybeLoadNextCompanyPage(event.currentTarget),
                },
              }}
              sx={{
                width: { xs: 190, sm: 280, md: 340 },
                '& .MuiAutocomplete-popupIndicator': { color: 'rgba(255,255,255,0.85)' },
                '& .MuiAutocomplete-clearIndicator': { color: 'rgba(255,255,255,0.85)' },
              }}
            />
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={"primary-search-account-menu"}
              aria-haspopup="true"
              onClick={handleAccountMenuToggle}
              color="inherit"
              ref={anchorRef}
              sx={{
                border: '1px solid rgba(255,255,255,0.42)',
                backgroundColor: 'rgba(255,255,255,0.12)',
                width: 38,
                height: 38,
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
              }}
            >
              {userInitial ? (
                <Avatar
                  sx={{
                    width: 30,
                    height: 30,
                    fontSize: '0.85rem',
                    fontWeight: 700,
                    bgcolor: 'rgba(255,255,255,0.9)',
                    color: BRAND_DEEP,
                  }}
                >
                  {userInitial}
                </Avatar>
              ) : (
                <AccountCircle />
              )}
            </IconButton>
            <Popper
              open={isMenuOpen}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              sx={{ zIndex: 1400 }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper sx={{ mt: 0.75, borderRadius: 2, minWidth: 150, boxShadow: '0 10px 28px rgba(2, 6, 23, 0.18)' }}>
                    <ClickAwayListener
                      onClickAway={handleAccountMenuClose}
                    >
                      <MenuList
                        autoFocusItem={isMenuOpen}
                        id="menu-list-grow"
                      >
                        {/* {userInfo &&
                          Boolean(userInfo.is_staff) &&
                          <MenuItem
                            onClick={() =>
                              this.handleProfileView()
                            }
                          >
                            Profile
                          </MenuItem>
                        }
                        {userInfo &&
                          !userInfo.is_superuser &&
                          !userInfo.is_staff &&
                          <MenuItem
                            onClick={() =>
                              navigate('/dashboard')
                            }
                          >
                            Profile
                          </MenuItem>
                        } */}
                        {/* <MenuItem onClick={() => this.forgotPassword(true)}>
                          Change Password
                        </MenuItem> */}
                        <MenuItem onClick={handlePasswordDialogOpen}>
                          Change Password
                        </MenuItem>
                        <MenuItem
                          onClick={() => { handleAccountMenuClose(); logoutFromScreen(); }}
                          sx={{ py: 1.25, fontWeight: 500 }}
                        >
                          Logout
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
        </Toolbar>

      </AppBar>
      <nav
        className={isMobile ? 'drawerMobileHost' : (open ? 'drawer' : 'drawerClosed')}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        {/* <Hidden smUp implementation="css"> */}

        <Drawer
          variant={isMobile ? 'temporary' : 'permanent'}
          open={open}
          onClose={handleDrawerClose}
          ismobile={isMobile ? 1 : 0}
          ModalProps={{ keepMounted: true }}
          PaperProps={{
            className: 'drawerPaper',
            sx: {
              borderRight: '1px solid',
              borderColor: 'divider',
              bgcolor: '#F8FAFC',
              width: drawerWidth,
            },
          }}
        >
          <DrawerHeader className="drawerHeaderBar">
            <div className={open ? 'sidebarBrand' : 'sidebarBrandCollapsed'}>
              <div className="sidebarBrandLogoWrap">
                <img src={logoImage} alt="Edubricz logo" className="sidebarBrandImg" />
              </div>
              {open && (
                <div className="sidebarBrandTextWrap">
                  <span className="sidebarBrandText">Edubricz</span>
                </div>
              )}
            </div>
            <IconButton onClick={handleDrawerClose} size="small" className="sidebarCollapseBtn" sx={{ color: BRAND_DEEP }}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider sx={{ opacity: 0.6 }} />
          <List
            disablePadding
            component="nav"
            className="drawerNavList"
            sx={{ py: 0.5, flex: 1, width: '100%' }}
          >
            {Object.keys(filteredMenuJson).map((text) => (
              <ListItem
                key={text}
                disablePadding
                className="drawerNavSection"
                sx={{ display: 'block', width: '100%' }}
              >
                <Tooltip title={text} placement="right" arrow enterDelay={400} disableHoverListener={open} disableTouchListener>
                  <ListItemButton
                    onClick={() => handleMenu(text)}
                    selected={isMenuRowSelected(text)}
                    sx={{
                      minHeight: 48,
                      mx: 1,
                      mb: 0.25,
                      borderRadius: 2,
                      justifyContent: open ? 'initial' : 'center',
                      px: open ? 2 : 1,
                      color: 'text.primary',
                      '&.Mui-selected': {
                        bgcolor: 'rgba(70, 128, 255, 0.14)',
                        color: BRAND_DEEP,
                        '&:hover': { bgcolor: 'rgba(70, 128, 255, 0.2)' },
                      },
                      '&:hover': { bgcolor: 'rgba(70, 128, 255, 0.08)' },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      {getMenuIcon(text)}
                    </ListItemIcon>
                    <ListItemText
                      primary={text}
                      primaryTypographyProps={{ fontWeight: 500, fontSize: '0.9rem' }}
                      sx={{ opacity: open ? 1 : 0, transition: 'opacity 0.2s' }}
                    />
                    {filteredMenuJson[text]['subMenu'] && open && (
                      openSubMenus[text] ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />
                    )}
                  </ListItemButton>
                </Tooltip>
                {filteredMenuJson[text]['subMenu'] && (
                  <Collapse in={open && Boolean(openSubMenus[text])} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding sx={{ pb: 0.5 }}>
                      {Object.keys(filteredMenuJson[text]['subMenu']).map((subText) => (
                        <ListItemButton
                          key={subText}
                          className="drawerSubMenuItem"
                          selected={isPathActive(filteredMenuJson[text]['subMenu'][subText]['url'])}
                          sx={{
                            pl: 3,
                            pr: 2,
                            ml: 2,
                            mr: 1,
                            mb: 0.25,
                            borderRadius: 2,
                            minHeight: 40,
                            alignItems: 'center',
                            borderLeft: '3px solid transparent',
                            '& .MuiListItemText-root': { my: 0 },
                            '& .MuiListItemText-primary': {
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              fontSize: '0.875rem',
                            },
                            '&.Mui-selected': {
                              backgroundColor: 'rgba(70, 128, 255, 0.12)',
                              borderLeftColor: BRAND_PRIMARY,
                              color: BRAND_DEEP,
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: 'rgba(70, 128, 255, 0.18)',
                            },
                            '&:hover': { backgroundColor: 'rgba(70, 128, 255, 0.06)' },
                          }}
                          onClick={() => handleSubMenu(text, subText)}
                        >
                          <ListItemText primary={subText} />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                )}
              </ListItem>
            ))}
          </List>
          <Divider />
        </Drawer>
        {/* </Hidden> */}
      </nav>
      <main className={'content'}>
        <DrawerHeader />
        <Box className="layoutContent">
          <Box className={"DrawerChildren"}>{props.children}</Box>
        </Box>
        {/* <div className="footer">
            <span>&copy; Edubricz - {(new Date()).getFullYear()}
            <div
              className={`scroll-to-top ${
                showTopInd ? "show-top-ind" : "no-show-top-ind"
              }`}
              onClick={this.scrollToTop}
            >
              <i className="fa fa-2x fa-angle-up scroll-top-icon"></i>
            </div>
            </span>
          </div> */}
      </main>

      <Dialog open={passwordDialogOpen} onClose={handlePasswordDialogClose} maxWidth="sm" fullWidth>
        <DialogTitle>Change Password</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            type={showPassword ? 'text' : 'password'}
            label="New Password"
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mt: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePasswordDialogClose} disabled={savingPassword}>Cancel</Button>
          <Button 
            onClick={handlePasswordSave} 
            variant="contained" 
            disabled={savingPassword || !newPassword}
            startIcon={savingPassword ? <CircularProgress size={20} /> : null}
          >
            Save Password
          </Button>
        </DialogActions>
      </Dialog>


    </Box>
  );
}

export default MiniDrawer